import React from "react";
import thumbsDown from "../../../assets/img/thumbs_down.svg";
import thumbsUp from "../../../assets/img/thumbs_up.svg";
import Trophy from "../../../assets/img/Trophy.svg"
import styles from "./historyMessages.module.scss";
import { historyMessagesProps, IhistoryData } from "./historyMessages.types";

export const TEST_ID = "historyMessages";

const renderMessages = (data: IhistoryData[]) => {
  return (
    <div className={styles.messages}>
      {data.map((message) => (
          <div className={styles.messages__content} key={message.id}>
            <div className={styles.messages__content__text}>
              <img 
                src={message.type === "losing" ? thumbsDown : thumbsUp}
                alt="thumbs icon"
              />
              <p>{message.text}</p>
            </div>
            <span>{message.time}</span>
          </div>
      ))}
    </div>
  );
};

export const HistoryMessages: React.FC<historyMessagesProps> = ({
  dataMessages,
  winner
}) => (
  <div data-testid={TEST_ID} className={styles.historyMessages}>
    <h3 className={styles.historyMessages__heading}>
      Histórico de mensagens
    </h3>
    {winner && (
      <div className={styles.winnerContent}>
        <img 
          src={Trophy}
          alt="trophy icon"
        />
        <div className={styles.winnerContent__message}>
          <strong>Parabéns!</strong>
          <span>Você arrematou o lote!</span>
        </div>
      </div>
    )}
    {renderMessages(dataMessages)}
  </div>
);
